import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage";
import * as jsPDF from 'jspdf';
import { EISAI_LOGO_FR } from '../images';
import { DatabaseProvider } from '../database/database';
import moment from 'moment';
import { PatientProvider } from '../patient/patient';

@Injectable()
export class PdfProviderFR {

  pdf: any;
  pageHeight: number;
  pageWidth: number;
  pageNumber: number = 0;
  startx: number = 40;
  starty: number = 40;
  x: number = 40;
  y: number = 40;
  supplies: any[];
  final_paragraph = `Si vous avez des questions ou des préoccupations, veuillez contacter votre représentant Eisai ou l’équipe du Programme de soutien aux patients Eisai prend soin de vous. Le programme est disponible de lundi à vendredi de 8 h à 20 h (HNE), hors des jours fériés.`;

  clinic: any;

  task: AngularFireUploadTask;
  filepath: any;

  constructor(private afStorage: AngularFireStorage, private database: DatabaseProvider, private db: PatientProvider) {
  }

  public createLetter(program_id, program_name, patient, letter_type, custom_text, user)  {
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pdf.deletePage(1);

    return new Promise((resolve, reject) => {
      const start = async () => {
        if (letter_type === 'Reimbursement Status Update')  {
          await this.reimbursementLetter(program_name, patient, custom_text);
        } else if (letter_type === 'Enrolment Form Received Confirmation') {
          await this.enrolmentReceived(program_name, patient, null);
        } else if (letter_type === 'Prescription Renewal Request') {
          await this.rxRenewal(program_name, patient, null);
        } else if (letter_type === 'Special Authorization Request') {
          await this.saRequest(program_name, patient, null);
        } else if (letter_type === 'Patient’s Coverage Secured') {
          await this.coverageSecured(program_name, patient, null);
        } else if (letter_type === 'Patient’s Coverage Denied') {
          await this.coverageDenied(program_name, patient, custom_text);
        } else if (letter_type === 'Unable to Contact Patient') {
          await this.unableToContact(program_name, patient, custom_text);
        } else if (letter_type === 'Patient Has Declined to Enrol') {
          await this.declinedEnrolment(program_name, patient, custom_text);
        } else if (letter_type === 'Notice of Discontinuation') {
          await this.discontinuationNotice(program_name, patient, custom_text);
        } else if (letter_type === 'Missing Information') {
          await this.missingInformation(program_name, patient, custom_text);
        } else if (letter_type === 'Medical Clarification') {
          await this.medicalClarification(program_name, patient, custom_text);
        } else {
          reject('Letter not found');
        }
        console.log('done pdf');
        // this.pdf.save('test.pdf');
        // resolve('test');
        const file = this.pdf.output("blob")
        const filepath = await this.uploadLettertoFirebase(program_id, program_name, patient, file, letter_type, user);
        console.log('Finished Everything, here is the file: ', filepath);
        resolve(filepath);
      }
      start();
    });
  }

  private async reimbursementLetter(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme de soutien aux patients (PSP) Eisai prend soin de vous.`;
      const paragraph2 = `Nous sommes actuellement dans le processus d’assurer la couverture pour le médicament ${patient.therapy}® pour ${patient.first_name + ' ' + patient.last_name}. À ce moment, nous sommes dans l’attente de:`;
      const paragraph3 = custom_text;
      const paragraph4 = `Nous vous informerons une fois que la couverture de ${patient.therapy}® soit déterminée pour ${patient.first_name + ' ' + patient.last_name}.  ` + this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Mise à jour - statut du remboursement', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      this.y += 15;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      let para3 = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para3.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para3); this.y += 25;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(12);
      this.y += textheight;

      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async enrolmentReceived(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme de soutien aux patients (PSP) Eisai prend soin de vous.`;
      const paragraph2 = `Veuillez accepter cette lettre comme confirmation que nous avons reçu le formulaire d’inscription et que nous sommes actuellement dans le processus de nous mettre en contact avec ${patient.first_name + ' ' + patient.last_name}. Le programme vous tiendra au courant une fois que l’inscription soit complétée.`;
      const paragraph3 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Confirmation de réception du formulaire d’inscription', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async rxRenewal(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Merci d'avoir orienté, ${patient.first_name + ' ' + patient.last_name} au Programme de soutien aux patients (PSP) Eisai prend soin de vous. `;
      const paragraph2 = `Veuillez noter que le programme a été informé par la pharmacie que le patient a utilisé son dernier renouvellement pour ${patient.therapy}® et donc aura besoin d’une nouvelle ordonnance. S.V.P voir ci-joint une copie du formulaire d’inscription pré rempli. Veuillez s.v.p. compléter les sections suivantes et le retourner au programme par télécopieur ou par courriel.`;
      const paragraph3 = `Une fois que nous ayons reçu le formulaire, nous enverrons l’ordonnance à la pharmacie au nom du patient.`;
      const paragraph4 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Renouvellement de l’ordonnance', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('•	Posologie', this.x + 50, this.y); this.y += 15;
      this.pdf.text('•	Nombre de renouvellements', this.x + 50, this.y); this.y += 15;
      this.pdf.text('•	Signature et la date ', this.x + 50, this.y); this.y += 30;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async saRequest(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme de soutien aux patients (PSP) Eisai prend soin de vous.`;
      const paragraph2 = `Soyez informé que la compagnie d’assurance privée de ${patient.first_name + ' ' + patient.last_name} demande que nous complétions un formulaire de demande d’autorisation afin de demander la couverture de ${patient.therapy}®. Nous avons prérempli le formulaire avec les informations que nous connaissions et nous avons souligné ce qui reste à compléter. Veuillez s.v.p. vérifier, compléter, signer et dater le formulaire et le retourner au programme par télécopieur au 1-800-980-0416.`;
      const paragraph3 = `Une fois que nous ayons reçu le document le programme enverra la demande à ${patient.first_name + ' ' + patient.last_name} afin de le vérifier. Nous vous tiendrons au courant une fois qu’une décision soit prise.`;
      const paragraph4 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Demande d’autorisation', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 25 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async coverageSecured(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Nous avons le plaisir de vous informer que la couverture pour le médicament ${patient.therapy}® a été approuvé pour ${patient.first_name + ' ' + patient.last_name}, nous avons informé la pharmacie et la livraison du médicament est en cours de traitement.`;
      const paragraph2 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Patient’s Coverage Secured', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 25 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 40 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async coverageDenied(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme Eisai prend soin de vous.`;
      const paragraph2 = `Soyez informé que ${patient.first_name + ' ' + patient.last_name} a été refusé(e) par leur assureur privé suite à la demande de couverture de ${patient.therapy}® pour la/les raison/s suivante/s:`;
      const paragraph3 = `Nous croyons qu’il y a une occasion de faire un appel à la décision en leur fournissant avec de l’information additionnelle.`;
      const paragraph4 = `Afin de vous aider, nous avons créé un modèle d’une lettre d’appel pour que vous pouvez réviser et ajoutez plus d’information si vous le souhaitez. Veuillez fournir n’importe quelle information clinique qui pourrait aider à assurer la couverture demandée. Une fois terminée, veuillez la signer, dater et la retourner au Programme Eisai prend soin de vous, par télécopieur ou par courriel, et nous l’enverrons a l’assureur privé afin d’essayer de renverser leur décision précédente.`;
      const paragraph5 = `Par conséquent, le Programme Eisai prend soin de vous suivra la demande du patient avec l’assureur privé et vous tiendra au courant une fois qu’une réponse soit reçue.`;
      const paragraph6 = this.final_paragraph;

      await this.addNewPage(program_name);
    
      this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Couverture du patient refusée', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 35;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;

      this.pdf.setFontType("normal");

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 25;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(11);
      this.pdf.setFontType("normal");
      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      para = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para); this.y += 20 + textheight;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(11);
      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph5, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph6, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous - info@eisaicares.ca', this.x, this.y); this.y += 15;
      resolve('Finished Letter');
    });
  }

  private async unableToContact(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Soyez informé qu’après après plusieurs tentatives, nous n’avons pas réussi à rejoindre  ${patient.first_name + ' ' + patient.last_name}.`;
      const paragraph2 = `Le(s) numéro(s) de téléphone dans le dossier est ${patient.program_patient_id}. Si vous avez un numéro de contact alternatif et/ou adresse courriel, veuillez-nous l’envoyez par fax, téléphone ou adresse courriel. Si de l’information alternative n’est pas disponible à ce moment, veuillez demander au patient de contacter le programme directement au 1-844-980-0410.`;
      const paragraph3 = `Veuillez noter que nous avons mis le dossier en attente jusqu’a ce que le patient contacte le programme ou que nous ayons obtenu d’autres informations de contact, ou si des instructions supplémentaires ont été fournies par votre bureau.`;
      const paragraph4 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Incapable de rejoindre le patient', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async declinedEnrolment(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme Eisai prend soin de vous.`;
      const paragraph2 = `Soyez informé que nous avons contacté ${patient.first_name + ' ' + patient.last_name} et que nous avons essayé de compléter leur inscription au Programme Eisai prend soin de vous. Malheureusement, ${patient.first_name + ' ' + patient.last_name} a refusé de s’inscrire au programme pour la/les raison/s suivante/es.`;
      const paragraph3 = `Nous avons fermé le dossier de ${patient.first_name + ' ' + patient.last_name}mais au cas où le patient voudra procéder avec l’inscription, veuillez le faire contacter le programme et ça nous fera plaisir de procéder.`;
      const paragraph4 = this.final_paragraph;

      await this.addNewPage(program_name);
    
      this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Le patient refuse de s’inscrire', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 35;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;

      this.pdf.setFontType("normal");

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 25;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(11);
      this.pdf.setFontType("normal");
      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      para = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para); this.y += 20 + textheight;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(11);

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous - info@eisaicares.ca', this.x, this.y); this.y += 15;
      resolve('Finished Letter');
    });
  }

  private async discontinuationNotice(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      // Create New Reimbursement Letter
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name}au Programme Eisai prend soin de vous.`;
      const paragraph2 = `Soyez informé que ${patient.first_name + ' ' + patient.last_name} a décidé d’arrêter leur traitement de ${patient.therapy} pour la/les raison/s suivante/s:`;
      const paragraph3 = `Nous avons encouragé le patient à faire un suivi avec votre bureau afin de discuter leurs options de traitement. Veuillez noter que nous avons fermé le dossier de ${patient.first_name + ' ' + patient.last_name} mais nous pouvons le rouvrir à tout instant en suivant vos instructions.`;
      const paragraph4 = this.final_paragraph; 

      await this.addNewPage(program_name);
    
      this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Avis de cessation du traitement', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 35;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;

      this.pdf.setFontType("normal");

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 25;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(11);
      this.pdf.setFontType("normal");
      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      this.pdf.setFontType("bold");
      this.pdf.setFontSize(10);
      para = this.pdf.splitTextToSize(custom_text, this.pageWidth - 140);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x + 20, this.y, para); this.y += 20 + textheight;
      this.pdf.setFontType("normal");
      this.pdf.setFontSize(11);

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 15 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous - info@eisaicares.ca', this.x, this.y); this.y += 15;
      resolve('Finished Letter');
    });
  }

  private async missingInformation(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme Eisai prend soin de vous.`;
      const paragraph2 = `Nous avons reçu le formulaire d’inscription de ${patient.first_name + ' ' + patient.last_name} et en vérifiant il a été noté qu’il manque des informations.`;
      const paragraph3 = `Afin de facilite la tâche, nous avons souligné les champs obligatoires nécessaires pour compléter l’inscription. Le dossier de ${patient.first_name + ' ' + patient.last_name} a été mis en attente jusqu’à la réception d’informations demandées. S.V.P nous fournir l’information par télécopieur ou par courrier électronique à votre plus tôt convenance.`;
      const paragraph4 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Information manquante', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  private async medicalClarification(program_name, patient, custom_text)  {
    return new Promise(async (resolve, reject) => {
      const paragraph1 = `Merci d'avoir orienté ${patient.first_name + ' ' + patient.last_name} au Programme Eisai prend soin de vous.`;
      const paragraph2 = `Le programme Eisai prend soin de vous a reçu le formulaire d’inscription de ${patient.first_name + ' ' + patient.last_name} et selon l’information reçue le patient(e) ne répondre pas au critères pour avoir un couverture pour le médicament. Le Programme Eisai prend soin de vous est un programme disponible aux patients diagnostiqués avec ${custom_text} selon le Conseil de Santé Canada.`;
      const paragraph3 = `Veuillez confirmer le diagnostic de ${patient.first_name + ' ' + patient.last_name} et par conséquent, le mettre à jour sur le formulaire ci-joint.`;
      const paragraph4 = this.final_paragraph;
        
      await this.addNewPage(program_name);
    
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Clarification médicale', this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 40;
      this.pdf.setFontSize(28);
      this.pdf.text('TÉLÉCOPIEUR', this.x, this.y); this.y += 35;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Doctor and NCM Line
      this.pdf.text('À: Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y);
      this.pdf.text('De la part de: ' + patient.case_manager, this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Fax # and Date
      const fax_number = patient.doctor.fax_number ? patient.doctor.fax_number : 'NA';
      this.pdf.text('Téléc: ' + fax_number, this.x, this.y);
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x + 250, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;

      // Patient
      this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 30;

      // Doctor Repeated 
      this.pdf.text('Dr. ' + patient.doctor.first_name + ' ' + patient.doctor.last_name, this.x, this.y); this.y += 30;

      // Patient
      this.pdf.setFontType("bold");
      if(patient.dob) {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id + ' - ' + moment(patient.dob.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 25;
      } else {
        this.pdf.text('Re: ' + patient.first_name + ' ' + patient.last_name + ' - ' + patient.program_patient_id, this.x, this.y); this.y += 25;
      }

      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      let para = this.pdf.splitTextToSize(paragraph1, this.pageWidth - 100);
      let textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

      para = this.pdf.splitTextToSize(paragraph2, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 25 + textheight;

      para = this.pdf.splitTextToSize(paragraph3, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;
      
      para = this.pdf.splitTextToSize(paragraph4, this.pageWidth - 100);
      textheight = 10 * para.length * 1.05;
      this.pdf.text(this.x, this.y, para); this.y += 30 + textheight;

      this.pdf.text('Sincères salutations,', this.x, this.y); this.y += 15;
      this.pdf.text(patient.case_manager, this.x, this.y); this.y += 15;
      this.pdf.text('Infirmière Gestionnaire de cas', this.x, this.y); this.y += 15;
      this.pdf.text('Programme Eisai prend soin de vous', this.x, this.y); this.y += 15;
      this.pdf.text('info@eisaicares.ca', this.x, this.y); this.y += 15;

      resolve('Finished Letter');
    });
  }

  public createOrder(program_id, program_name, patient, order, user) {
    console.log('Creating order for order: ', order);
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pdf.deletePage(1);

    return new Promise((resolve, reject) => {
      const start = async () => {
        await this.addOrder(program_name, patient, order);
        console.log('done pdf');
        // this.pdf.save('test.pdf');
        // resolve('test');
        const file = this.pdf.output("blob")
        const filepath = await this.uploadOrdertoFirebase(program_id, program_name, patient, file, 'Order', order.order_number, user);
        console.log('Finished Everything, here is the file: ', filepath);
        resolve(filepath);
      }
      start();
    });
  }

  private async addOrder(program_name, patient, order)  {
    return new Promise(async (resolve, reject) => {
      
      await this.addNewPage('DISTRIBUTORS - Insert a copy with shipment - Enrolment Form Attached');

      // Header
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      if (order.type === 'Drug') {
        this.pdf.text(order.commercial_compassionate + ' Order - ' + order.order_number, this.pageWidth / 2, this.y, 'center'); this.y += 5;
      } else {
        this.pdf.text(order.type + ' - ' + order.order_number, this.pageWidth / 2, this.y, 'center'); this.y += 5;
      }
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Date
      this.pdf.text('Date: ' + moment().format('MMM-DD-YYYY'), this.x, this.y); this.y += 15;

      // NCM
      this.pdf.text('Case Worker: ' + patient.case_manager, this.x, this.y); this.y += 15;

      // NCM
      this.pdf.text('Order Number: ' + order.order_number, this.x, this.y); this.y += 15;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;

      this.pdf.setFontType("bold");
      this.pdf.text('Patient', this.x, this.y);
      this.pdf.text('Physician', this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text('Pharmacy', this.x + 400, this.y); 
      this.y += 15;

      this.pdf.setFontType("normal");
      this.pdf.text(patient.first_name + ' ' + patient.last_name, this.x, this.y);
      this.pdf.text('Dr. ' + order.doctor.first_name + ' ' + order.doctor.last_name, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.name, this.x + 400, this.y); 
      this.y += 15;

      this.pdf.text(patient.address, this.x, this.y);
      if (order.doctor.address) this.pdf.text(order.doctor.address, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.address, this.x + 400, this.y); this.y += 15;

      this.pdf.text(patient.city + ', ' + patient.province, this.x, this.y);
      if (order.doctor.address) this.pdf.text(order.doctor.city + ', ' + order.doctor.province, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.city + ', ' + order.pharmacy.province, this.x + 400, this.y); this.y += 15;

      this.pdf.text(patient.postal_code, this.x, this.y);
      if (order.doctor.address) this.pdf.text(order.doctor.postal_code, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text(order.pharmacy.postal_code, this.x + 400, this.y); this.y += 15;

      if (patient.dob) this.pdf.text('DOB: ' + moment(patient.dob.seconds * 1000).format('MMM-DD-YYYY'), this.x, this.y);
      if (order.doctor.fax_number) this.pdf.text('FAX: ' + order.doctor.fax_number, this.x + 200, this.y);
      if (order.pharmacy) this.pdf.text('FAX: ' + order.pharmacy.fax_number, this.x + 400, this.y); 
      this.y += 15;
      
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;

      // Therapy and Indication
      if (order.type === 'Drug') {
        if (patient.therapy) this.pdf.text('Therapy: ' + patient.therapy + ' - ' + order.commercial_compassionate, this.x, this.y); this.y += 15;
        if (patient.indication) this.pdf.text('Indication: ' + patient.indication, this.x, this.y); this.y += 15;
        this.pdf.text('Dose: ' + order.dose, this.x, this.y); this.y += 15;
        this.pdf.text('Repeats: ' + order.repeats, this.x, this.y); this.y += 15;
        this.pdf.text('Quantity: ' + order.quantity, this.x, this.y); this.y += 15;
      } else {
        this.pdf.text(order.type, this.x, this.y); this.y += 15;
        if (patient.therapy) this.pdf.text('Therapy: ' + patient.therapy, this.x, this.y); this.y += 15;
        if (patient.indication) this.pdf.text('Indication: ' + patient.indication, this.x, this.y); this.y += 15;
      }

      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;
      this.pdf.setFontType("bold");
      this.pdf.text('Instructions', this.x, this.y); this.y += 15;

      this.pdf.setFontType("normal");
      if (order.notes)  {
        let notes = this.pdf.splitTextToSize(order.notes, this.pageWidth - 100);
        this.pdf.text(this.x, this.y, notes); this.y += 25;
      }
      resolve('Finished Order Contents');
    });
  }

  private async addNewPage(program_name) {
    return new Promise(async (resolve, reject) => {
      this.pdf.addPage();
      this.pageNumber += 1;
      this.y = this.starty;
      await this.addHeader(program_name);
      await this.addFooter(program_name);
      resolve('New Page Added');
    });
  }

  private async addHeader(program_name) {
    return new Promise((resolve, reject) => {
      this.y = 40; 
      this.x = 40;

      // Add Eisai Logo
      this.pdf.addImage(EISAI_LOGO_FR, 'png', this.x, this.y, 130, 65); this.y += 20;

      // Eisai Top Right Info
      this.pdf.setFont("helvetica"); 
      this.pdf.setFontType("bold");
      this.pdf.setFontSize(14);
      this.pdf.text('TÉLÉPHONE:', this.x + 290, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('1-844-980-0410', this.x  + 415, this.y); this.y += 20;

      this.pdf.setFontType("bold");
      this.pdf.text('TÉLÉCOPIEUR:', this.x + 290, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('1-844-980-0416', this.x + 415, this.y); this.y += 20;

      this.pdf.setFontType("bold");
      this.pdf.text('COURRIEL:', this.x + 290, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('info@eisaicares.ca', this.x + 415, this.y); this.y += 20;
      this.pdf.setFontType("normal"); 
      resolve();
    });
  }

  private addFooter(program_name)  {
    return new Promise((resolve, reject) => {
      // Footer with Clinic and Page Number
      this.pdf.setFontSize(12);
      this.pdf.line(this.x, this.pageHeight - 40, this.pageWidth - 40, this.pageHeight - 40);
      let nextline = program_name;
      // if(batch.order_batch) { nextline += ' - ' + batch.order_batch; }
      this.pdf.text(nextline, this.x, this.pageHeight - 25);
      // this.pdf.text(this.pageNumber.toString(), this.pageWidth - 60, this.pageHeight - 25);
      resolve('Footer Complete');
    });
  }

  private async uploadLettertoFirebase(program_id, program_name, patient, file: any, doc_type, user) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      const dt = new Date().getTime();
      const filename = `${dt}_Letter_${patient.program_patient_id}_${patient.last_name}_FR.pdf`;
      filePath = 'documents/' + filename;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("File Upload Complete: ", file); 
          file['ext'] = 'pdf';
          file['url'] = u;
          file['doc_type'] = doc_type;
          file['mimetype'] = 'application/pdf';
          file['filename'] = filename;
          const patientnew = {
            id: patient.id,
            first_name: patient.first_name,
            last_name: patient.last_name,
            program_patient_id: patient.program_patient_id
          }
          this.db.addDocument(program_id, patientnew, file, user, 'Letter', doc_type)
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  private async uploadOrdertoFirebase(program_id, program_name, patient, file: any, doc_type, order_id, user) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      const dt = new Date().getTime();
      const filename = `${dt}_${order_id}_${patient.program_patient_id}_${patient.last_name}.pdf`;
      filePath = 'orders/' + filename;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("Order Upload Complete: ", file); 
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/pdf/pdfFR.ts